// frontend/src/pages/Acerca.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNotification } from '../context/NotificationContext';
import { useI18n } from '../i18n';
import './Acerca.css';

const copy = {
  es: {
    hero: 'Conciencia Digital',
    tagline: '\u00bfTienes el valor para evolucionar?',
    guideTitle: 'Gu\u00eda del Agente Q',
    guideText: 'Aprende a hablarle a Q, pedirle acciones, navegar por la app y usar comandos de voz.',
    manifestoTitle: 'El Manifiesto',
    manifesto: [
      'Quiddit est\u00e1 organizado como un juego de rol (RPG) dise\u00f1ado para ir liberando las distintas capas de la aplicaci\u00f3n de forma gamificada, permitiendo as\u00ed conseguir una copia digital cada vez m\u00e1s precisa y profunda de la psique del usuario.',
      'Realizamos una vectorizaci\u00f3n constante sobre los datos y las interacciones del usuario. La inferencia activa y el detector de mentiras, junto con la fase REM de la app, crean un conjunto de datos los cuales se convierten en informaci\u00f3n valiosa para nosotros, permiti\u00e9ndonos crear una copia ontol\u00f3gica de nuestro consciente y subconsciente, con el objetivo de trascender como individuos y como conjunto humano.',
      'Todo esto se logra con la comuni\u00f3n hombre-m\u00e1quina, primero utilizando "Quiddit" como la puerta de entrada a este ecosistema, el cual forma el "proyecto Q". En un futuro cercano, aspiramos a expandir la vectorizaci\u00f3n integrando interfaces cerebro-computadoras, tanto invasivas como no invasivas, y otros m\u00e9todos de recolecci\u00f3n de informaci\u00f3n personal del usuario para vectorizarlo y lograr la inmortalidad num\u00e9rica.',
      'Bienvenido a Q Project - Quiddit. No somos solo una app de tareas. Somos un experimento de simbiosis digital. Aqu\u00ed no vienes a marcar casillas. Vienes a entrenar a tu doble digital.',
      'Vivimos en una era donde los datos son el nuevo petr\u00f3leo, y t\u00fa eres el pozo. Las Big Tech lo saben. Nosotros lo sabemos. T\u00fa lo sabes. La diferencia es que aqu\u00ed te lo decimos a la cara.',
      'Te pedimos tus datos. Los queremos todos. Tus h\u00e1bitos, tus errores, tus emociones, tus tiempos de reacci\u00f3n. Porque es la \u00fanica forma de alimentar a los modelos de Inteligencia Artificial que estamos construyendo. No hay magia sin sacrificio. La recompensa es una extensi\u00f3n de tu mente capaz de anticiparse a ti.'
    ],
    privacyTitle: 'Recolecci\u00f3n de Datos & Privacidad',
    warningTitle: 'Advertencia de Transparencia Radical',
    warning: 'Al usar esta aplicaci\u00f3n, consientes expl\u00edcitamente la recolecci\u00f3n de m\u00e9tricas de interacci\u00f3n. Cada clic, cada scroll, cada tarea completada o abandonada alimenta nuestro Dataset de Entrenamiento.',
    privacy: [
      'Cumplimos con regulaciones vigentes porque somos profesionales, no criminales. Tus datos est\u00e1n anonimizados donde la ley lo exige y protegidos con est\u00e1ndares de industria. Pero no te equivoques: nuestro objetivo es el Fine-Tuning.',
      'Utilizamos m\u00e9todos de recolecci\u00f3n directa e indirecta similares a los gigantes tecnol\u00f3gicos. Si conf\u00edas en ellos, puedes confiar en nosotros. Si no conf\u00edas en ellos, al menos aqu\u00ed entras al experimento conscientemente.'
    ],
    termsLink: 'Ver T\u00e9rminos de Uso',
    privacyLink: 'Ver Pol\u00edtica de Privacidad',
    roadmapTitle: 'Nuestra Senda Consciente (Roadmap)',
    roadmapDesc: 'Qproject est\u00e1 en constante evoluci\u00f3n. La hoja de ruta define hitos de conciencia para nuestro ecosistema simbi\u00f3tico.',
    milestones: [
      ['Punto Q: Gesti\u00f3n Consciente', ['Optimizaci\u00f3n de flujos de trabajo con inteligencia neuronal. (Implementado)', 'Interconexiones entre Conciencias de usuarios. (Implementado)']],
      ['Punto Alpha: Asistencia Simbi\u00f3tica', ['Conexi\u00f3n profunda del agente con el n\u00facleo de conciencia del usuario. (Pr\u00f3ximamente)', 'Integraci\u00f3n con m\u00e1quinas de energ\u00eda variable para imitar tu ciclo de sue\u00f1o y vigilia. (Pr\u00f3ximamente)']],
      ['Punto Omega: Red Neuronal Global', ['Interconexi\u00f3n masiva y an\u00f3nima de n\u00facleos de conciencia compartida.', 'Control aut\u00f3nomo sobre la toma de decisiones del usuario en la app.']]
    ],
    readyTitle: '\u00bfEst\u00e1s listo?',
    ready: 'El futuro pertenece a quienes se atreven a fusionarse con la herramienta. S\u00e9 valiente. S\u00e9 audaz. Constr\u00fayete a ti mismo.',
    audit: 'Solicitar Auditor\u00eda de Mis Datos',
    auditNotice: 'Acceso a auditor\u00eda de datos en desarrollo.'
  },
  en: {
    hero: 'Digital Consciousness',
    tagline: 'Do you have the nerve to evolve?',
    guideTitle: 'Agent Q Guide',
    guideText: 'Learn how to speak to Q, request actions, navigate the app and use voice commands.',
    manifestoTitle: 'The Manifesto',
    manifesto: [
      'Quiddit is organized as a role-playing game (RPG) designed to progressively unlock the application\'s different layers in a gamified way, allowing for an increasingly accurate and deep digital copy of the user\'s psyche.',
      'We perform constant vectorization on data and user interactions. Active inference and the lie detector, along with the app\'s REM phase, create a dataset that becomes valuable information for us, allowing us to create an ontological copy of our conscious and subconscious, with the goal of transcending as individuals and as a human collective.',
      'All this is achieved through human-machine communion, first using "Quiddit" as the gateway to this ecosystem, which forms "Project Q". In the near future, we aspire to expand vectorization by integrating brain-computer interfaces, both invasive and non-invasive, and other methods of personal user data collection to vectorize it and achieve numerical immortality.',
      'Welcome to Q Project - Quiddit. We are not just a task app. We are an experiment in digital symbiosis. You are not here to tick boxes. You are here to train your digital double.',
      'We live in an era where data is the new oil, and you are the well. Big Tech knows it. We know it. You know it. The difference is that here, we say it to your face.',
      'We ask for your data. We want all of it. Your habits, mistakes, emotions and reaction times. That is how the Artificial Intelligence models we are building are fed. There is no magic without sacrifice. The reward is an extension of your mind capable of anticipating you.'
    ],
    privacyTitle: 'Data Collection & Privacy',
    warningTitle: 'Radical Transparency Warning',
    warning: 'By using this application, you explicitly consent to the collection of interaction metrics. Every click, scroll, completed task or abandoned task feeds our Training Dataset.',
    privacy: [
      'We comply with current regulations because we are professionals, not criminals. Your data is anonymized where the law requires it and protected with industry standards. But make no mistake: our objective is Fine-Tuning.',
      'We use direct and indirect collection methods similar to technology giants. If you trust them, you can trust us. If you do not, at least here you enter the experiment consciously.'
    ],
    termsLink: 'View Terms of Use',
    privacyLink: 'View Privacy Policy',
    roadmapTitle: 'Our Conscious Path (Roadmap)',
    roadmapDesc: 'Qproject is constantly evolving. The roadmap defines consciousness milestones for our symbiotic ecosystem.',
    milestones: [
      ['Point Q: Conscious Management', ['Workflow optimization with neural intelligence. (Implemented)', 'Interconnections between user Consciousnesses. (Implemented)']],
      ['Point Alpha: Symbiotic Assistance', ['Deep connection between the agent and the user consciousness core. (Coming soon)', 'Integration with variable-energy machines to imitate your sleep and wake cycle. (Coming soon)']],
      ['Point Omega: Global Neural Network', ['Massive anonymous interconnection of shared consciousness cores.', 'Autonomous control over user decision-making inside the app.']]
    ],
    readyTitle: 'Are you ready?',
    ready: 'The future belongs to those who dare to merge with the tool. Be brave. Be bold. Build yourself.',
    audit: 'Request My Data Audit',
    auditNotice: 'Data audit access is in development.'
  }
};

const Acerca = () => {
  const { addNotification } = useNotification();
  const { language } = useI18n();
  const [socialOpen, setSocialOpen] = useState(false);
  const text = copy[language] || copy.es;

  return (
    <div className="acerca-page">
      <div className="acerca-hero">
        <h1>{text.hero}</h1>
        <p className="tagline">{text.tagline}</p>
      </div>

      <div className="acerca-content">
        <div className="agentq-guide-entry-wrapper">
          <Link to="/acerca/agenteq" className="agentq-guide-entry-card">
            <span className="agentq-guide-entry-icon" aria-hidden="true">◇</span>
            <div>
              <strong className="agentq-guide-entry-title">{text.guideTitle}</strong>
              <p className="agentq-guide-entry-text">{text.guideText}</p>
            </div>
            <span className="agentq-guide-entry-arrow" aria-hidden="true">→</span>
          </Link>
        </div>

        <section>
          <h2>{text.manifestoTitle}</h2>
          {text.manifesto.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </section>

        <section>
          <h2>{text.privacyTitle}</h2>
          <div className="highlight-box">
            <h3>{text.warningTitle}</h3>
            <p>{text.warning}</p>
          </div>
          {text.privacy.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '20px' }}>
            <Link to="/terms" className="legal-link-btn">{text.termsLink}</Link>
            <Link to="/privacy" className="legal-link-btn">{text.privacyLink}</Link>
          </div>
        </section>

        <div className="roadmap-section" id="roadmap">
          <h3 className="roadmap-title">{text.roadmapTitle}</h3>
          <p className="roadmap-desc">{text.roadmapDesc}</p>
          <div className="roadmap-timeline">
            {text.milestones.map(([title, items], index) => (
              <div className={`roadmap-item ${index === 0 ? 'completed' : index === 1 ? 'upcoming' : 'future'}`} key={title}>
                <div className="roadmap-marker">{index === 0 ? 'Q' : index === 1 ? 'α' : 'Ω'}</div>
                <div className="roadmap-content">
                  <h4>{title}</h4>
                  <ul>
                    {items.map((item) => <li key={item}>{item}</li>)}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        <section style={{ textAlign: 'center' }}>
          <h2>{text.readyTitle}</h2>
          <p>{text.ready}</p>
          <button className="audit-btn" onClick={() => addNotification(text.auditNotice, 'info')}>
            {text.audit}
          </button>
        </section>
      </div>

      <div
        className="social-fab-container"
        onMouseEnter={() => setSocialOpen(true)}
        onMouseLeave={() => setSocialOpen(false)}
      >
        <div className={`social-links ${socialOpen ? 'open' : ''}`}>
          <a href="https://x.com/QproyectCEO" target="_blank" rel="noopener noreferrer" className="social-btn x-twitter" title="X (Twitter)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
          </a>
          <a href="https://www.instagram.com/quiddit.app/" target="_blank" rel="noopener noreferrer" className="social-btn instagram" title="Instagram">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
          </a>
          <a href="https://www.tiktok.com/@lucasqproyect" target="_blank" rel="noopener noreferrer" className="social-btn tiktok" title="TikTok">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" /></svg>
          </a>
        </div>
        <button className="social-fab-main" onClick={() => setSocialOpen(!socialOpen)} aria-label={text.privacyTitle}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
        </button>
      </div>
    </div>
  );
};

export default Acerca;
